// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.login-tagline {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.15em;
  font-weight: 400;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.login-tagline__static {
  display: inline-flex;
  font-weight: 800;
}

.login-tagline__char {
  display: inline-block;
  opacity: 0;
  transform: translateY(16px);
  animation: letterIn 0.42s ease-out forwards;
  font-weight: 700;
  color: var(--brand-500);
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}

.login-tagline__char--train {
  font-weight: 800;
  color: var(--brand-500);
  text-shadow: 0 0 24px rgba(16, 185, 129, 0.35), 0 2px 10px rgba(0, 0, 0, 0.28);
}

.login-tagline__char--rotating {
  font-weight: 700;
  color: var(--brand-500);
}

.login-tagline__rotating-wrapper {
  display: inline-block;
  /* Reserves room for the longest word ("Classification", "Localization") so
     the headline doesn't jump on every rotation — but never wider than the
     column it sits in, or the word spills out of the hero. */
  min-width: min(15ch, 100%);
  max-width: 100%;
  text-align: left;
  vertical-align: baseline;
  overflow: visible;
}

.login-tagline__word {
  display: inline-block;
  white-space: nowrap;
  font-weight: 700;
}

.login-tagline__word--out .login-tagline__char {
  animation: letterOut 0.35s ease-in forwards;
}

.login-tagline__word--out .login-tagline__char:nth-child(1) {
  animation-delay: 0ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(2) {
  animation-delay: 30ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(3) {
  animation-delay: 60ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(4) {
  animation-delay: 90ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(5) {
  animation-delay: 120ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(6) {
  animation-delay: 150ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(7) {
  animation-delay: 180ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(8) {
  animation-delay: 210ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(9) {
  animation-delay: 240ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(10) {
  animation-delay: 270ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(11) {
  animation-delay: 300ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(12) {
  animation-delay: 330ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(13) {
  animation-delay: 360ms;
}

.login-tagline__word--out .login-tagline__char:nth-child(14) {
  animation-delay: 390ms;
}

.login-tagline__word--in .login-tagline__char {
  opacity: 0;
  transform: translateY(16px);
  animation: letterIn 0.45s ease-out forwards;
}

@keyframes letterIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes letterOut {
  to {
    opacity: 0;
    transform: translateY(10px);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/login/components/LoginTagline.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,gBAAA;AAAF;;AAMA;EACE,qBAAA;EACA,UAAA;EACA,2BAAA;EACA,2CAAA;EACA,gBAAA;EACA,uBARc;EASd,0CAAA;AAHF;;AAMA;EACE,gBAAA;EACA,uBAdc;EAed,8EACE;AAJJ;;AAQA;EACE,gBAAA;EACA,uBAtBc;AAiBhB;;AASA;EACE,qBAAA;EACA;;6DAAA;EAGA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AANF;;AASA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;AANF;;AAUA;EACE,2CAAA;AAPF;;AAUA;EAA8D,oBAAA;AAN9D;;AAOA;EAA8D,qBAAA;AAH9D;;AAIA;EAA8D,qBAAA;AAA9D;;AACA;EAA8D,qBAAA;AAG9D;;AAFA;EAA8D,sBAAA;AAM9D;;AALA;EAA8D,sBAAA;AAS9D;;AARA;EAA8D,sBAAA;AAY9D;;AAXA;EAA8D,sBAAA;AAe9D;;AAdA;EAA8D,sBAAA;AAkB9D;;AAjBA;EAA+D,sBAAA;AAqB/D;;AApBA;EAA+D,sBAAA;AAwB/D;;AAvBA;EAA+D,sBAAA;AA2B/D;;AA1BA;EAA+D,sBAAA;AA8B/D;;AA7BA;EAA+D,sBAAA;AAiC/D;;AA9BA;EACE,UAAA;EACA,2BAAA;EACA,2CAAA;AAiCF;;AA9BA;EACE;IACE,UAAA;IACA,2BAAA;EAiCF;EA/BA;IACE,UAAA;IACA,wBAAA;EAiCF;AACF;AA9BA;EACE;IACE,UAAA;IACA,2BAAA;EAgCF;AACF","sourcesContent":["// LoginTagline – alphabet-level: one letter after another\n\n.login-tagline {\n  display: inline-flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 0.15em;\n  font-weight: 400;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.login-tagline__static {\n  display: inline-flex;\n  font-weight: 800;\n}\n\n// Single color for all animation characters (Train + rotating word)\n$tagline-color: var(--brand-500);\n\n.login-tagline__char {\n  display: inline-block;\n  opacity: 0;\n  transform: translateY(16px);\n  animation: letterIn 0.42s ease-out forwards;\n  font-weight: 700;\n  color: $tagline-color;\n  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);\n}\n\n.login-tagline__char--train {\n  font-weight: 800;\n  color: $tagline-color;\n  text-shadow:\n    0 0 24px rgba(16, 185, 129, 0.35),\n    0 2px 10px rgba(0, 0, 0, 0.28);\n}\n\n.login-tagline__char--rotating {\n  font-weight: 700;\n  color: $tagline-color;\n}\n\n// Word container: letters stack in sequence\n.login-tagline__rotating-wrapper {\n  display: inline-block;\n  /* Reserves room for the longest word (\"Classification\", \"Localization\") so\n     the headline doesn't jump on every rotation — but never wider than the\n     column it sits in, or the word spills out of the hero. */\n  min-width: min(15ch, 100%);\n  max-width: 100%;\n  text-align: left;\n  vertical-align: baseline;\n  overflow: visible;\n}\n\n.login-tagline__word {\n  display: inline-block;\n  white-space: nowrap;\n  font-weight: 700;\n}\n\n// When word is exiting, letters fade down one after another (reverse stagger)\n.login-tagline__word--out .login-tagline__char {\n  animation: letterOut 0.35s ease-in forwards;\n}\n\n.login-tagline__word--out .login-tagline__char:nth-child(1) { animation-delay: 0ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(2) { animation-delay: 30ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(3) { animation-delay: 60ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(4) { animation-delay: 90ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(5) { animation-delay: 120ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(6) { animation-delay: 150ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(7) { animation-delay: 180ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(8) { animation-delay: 210ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(9) { animation-delay: 240ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(10) { animation-delay: 270ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(11) { animation-delay: 300ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(12) { animation-delay: 330ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(13) { animation-delay: 360ms; }\n.login-tagline__word--out .login-tagline__char:nth-child(14) { animation-delay: 390ms; }\n\n// When word is entering, each letter uses inline animationDelay (one after another)\n.login-tagline__word--in .login-tagline__char {\n  opacity: 0;\n  transform: translateY(16px);\n  animation: letterIn 0.45s ease-out forwards;\n}\n\n@keyframes letterIn {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes letterOut {\n  to {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
